export const englishData = [
  {
    Title: "Payment Successful!",
    title1: "Thank you for your payment. Your transaction has been completed successfully.",
    btnText: "Go to Home",
    title2: "You will be redirected to home in 5 seconds..",
    
  }
]

export const sinhalaData = [{
  Title: "ගෙවීම සාර්ථකයි!",
    title1: "ඔබගේ ගෙවීමට ස්තූතියි. ඔබගේ ගනුදෙනුව සාර්ථකව අවසන් කර ඇත.",
    btnText: "මුල් පිටුවට",
    title2: "තත්පර 5 කින් ඔබව මුල් පිටුවට යවනු ලැබේ..",
}]

export const tamilData = [{
   Title: "பணம் செலுத்தப்பட்டது!",
    title1: "பணம் செலுத்தியதற்கு நன்றி. உங்கள் பரிவர்த்தனை வெற்றிகரமாக முடிந்தது.",
    btnText: "முகப்புப் பக்கத்திற்கு",
    title2: "நீங்கள் 5 வினாடிகளில் முகப்புப் பக்கத்திற்கு அனுப்பப்படுவீர்கள்.",
}]

